/** Returns a copy of `ids` with `storeId` added (once) or removed (first occurrence only). */
export const toggleFavoriteId = (
  ids: readonly number[],
  storeId: number,
  isAdding: boolean
): number[] => {
  const next = [...ids]

  if (isAdding) {
    if (!next.includes(storeId)) next.push(storeId)
    return next
  }

  const index = next.indexOf(storeId)
  if (index > -1) next.splice(index, 1)
  return next
}
